import React, { useEffect, useState } from "react";
import Header from "../../partials/Header";
import Sidebar from "../../partials/Sidebar";
import BackIcon from "../../../assets/icons/icon-back.svg";
import UploadIcon from "../../../images/icon-upload.png";
import { useSelector } from "react-redux";
import { notification } from "antd";
import styles from "./style.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import AXIOS from "../../../config/axios";
import fetchSiteList from "../../../api/sites/fetchSiteList";
import fetchSizeList from "../../../api/lockers/fetchSizeList";
import QRCode from "qrcode";

const LockerEdit = () => {
  const isAuthenticated = useSelector((state) => state.user);
  const { id } = useParams();

  const url = process.env.REACT_APP_APP_BACK_URL;
  const [credentials, setCredentials] = useState({
    number: "",
    size_id: "",
    row: "",
    column: "",
    site_id: "",
    relay: "",
    comment: "",
    port: "",
    state:"",
    status: "",
    department_name: "",
    department_id: "",
    pin_code: "",
  });
  const isSuperAdmin =
    String(isAuthenticated?.role || "").toLowerCase() === "superadmin";
  const [departmentAccess, setDepartmentAccess] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [sizes, setSizes] = useState([]);
  const [getSite, setSite] = useState([]);
  const handleInput = (e) => {
    const next = { ...credentials, [e.target.name]: e.target.value };
    if (e.target.name === "site_id") next.department_name = "";
    if (
      e.target.name === "site_id" ||
      e.target.name === "department_name" ||
      e.target.name === "pin_code"
    ) {
      setQrImage("");
    }
    setCredentials(next);
  };
  const generatePasswordQr = async () => {
    const pinCode = String(credentials.pin_code || "").trim();
    if (!pinCode) {
      notification.error({
        message: "Password required",
        description: "Select a department that has a code.",
        duration: 3,
      });
      return;
    }
    try {
      const dataUrl = await QRCode.toDataURL(pinCode, {
        margin: 1,
        width: 220,
        errorCorrectionLevel: "M",
      });
      setQrImage(dataUrl);
    } catch (error) {
      notification.error({
        message: "Failed",
        description: "Could not generate the QR code.",
        duration: 3,
      });
    }
  };

  const formSubmit = async (e) => {
    e.preventDefault();
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    headers.append("auth-token", localStorage.getItem("token"));
    setIsLoading(true);
    const response = await fetch(`${url}/api/lockers/update/${id}`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        number: credentials.number,
        size_id: credentials.size_id,
        site_id: credentials.site_id,
        row: credentials.row,
        column: credentials.column,
        relay: credentials.relay,
        comment: credentials.comment,
        port: credentials.port,
        status: credentials.status,
        state:credentials.state,
        department_name: credentials.department_name,
        department_id: credentials.department_id,
        pin_code: credentials.pin_code,
      }),
    });
    setIsLoading(false);
    const json = await response.json();
    console.log(json);
    if (json.success) {
      notification.success({
        message: "Success",
        description: "Locked Updated Successfully",
        duration: 3,
      });
    } else {
      setIsLoading(false);
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  useEffect(() => {
    getLocker(id);
  }, [id]);
  useEffect(() => {
    const siteId = credentials.site_id;
    if (!siteId) {
      setDepartmentAccess(false);
      setDepartments([]);
      return;
    }
    let cancelled = false;
    const headers = new Headers();
    headers.append("auth-token", localStorage.getItem("token"));
    fetch(`${url}/api/sites/getSite/${siteId}`)
      .then((res) => res.json())
      .then(async (json) => {
        const enabled = json?.site?.departments_enabled === "yes";
        if (cancelled) return;
        setDepartmentAccess(enabled);
        if (!enabled) {
          setDepartments([]);
          return;
        }
        const response = await fetch(
          `${url}/api/department/list?site_id=${encodeURIComponent(siteId)}`,
          { headers }
        );
        const list = await response.json();
        if (!cancelled) {
          const rows = Array.isArray(list.data) ? list.data : [];
          setDepartments(rows);
          setCredentials((prev) => {
            const match = rows.find(
              (item) =>
                item._id === prev.department_id ||
                String(item.name || "").trim().toLowerCase() ===
                  String(prev.department_name || "").trim().toLowerCase()
            );
            if (!match) return prev;
            return {
              ...prev,
              department_id: match._id,
              department_name: match.name,
              pin_code: String(match.universal_code || "").trim(),
            };
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDepartmentAccess(false);
          setDepartments([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [credentials.site_id, url]);
  useEffect(() => {
    (async () => {
      const sizeData = await fetchSizeList();
      if (sizeData) {
        setSizes(sizeData.data);
      }
      const siteData = await fetchSiteList();
      if (siteData) {
        setSite(siteData.site_data);
      }
    })();
  }, []);
  const getLocker = async (id) => {
    try {
      AXIOS.get(`/lockers/${id}`)
        .then((res) => {
          setCredentials({ ...res?.data?.locker });
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {}
  };

  const [isActive, setIsActive] = useState(false);

  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };

  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";

  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/locker/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>Edit Locker</h3>
                  <p>
                    {isSuperAdmin
                      ? "Enter information to edit locker"
                      : "Update the department and password for this locker"}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end"></div>
          </div>
        </div>
        {/* row */}
        <form onSubmit={formSubmit}>
          <div className="form-box card-box">
            <div className="row">
              {isSuperAdmin && (
              <>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Locker No</h4>
                      <p>Enter the locker number</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="sitec"
                        placeholder="LS-001"
                        name="number"
                        value={credentials.number}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Size</h4>
                      <p>Select size for the locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="size_id"
                        value={credentials.size_id}
                        onChange={handleInput}
                        required
                      >
                        <option value="">Choose size</option>
                        {sizes.map((per) => (
                          <option
                            key={per._id}
                            value={per._id}
                            style={{ textTransform: "capitalize" }}
                          >
                            {per.size}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Row</h4>
                      <p>Enter number of rows for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="row"
                        value={credentials.row}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Column</h4>
                      <p>Enter number of column for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="column"
                        value={credentials.column}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4> Site</h4>
                      <p>Select the site for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="site_id"
                        value={credentials.site_id}
                        onChange={handleInput}
                        required
                      >
                        <option value="" selected>
                          Choose Site
                        </option>
                        {getSite.map((per) => (
                          <option key={per._id} value={per._id}>
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Status</h4>
                      <p>Select the status for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="status"
                        value={credentials.status}
                        onChange={handleInput}
                        required
                      >
                        <option value="" selected>
                          Choose Status
                        </option>
                        <option key={1} value={"available"}>
                          Available
                        </option>
                        <option key={2} value={"occupied"}>
                          Occupied
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Relay</h4>
                      <p>Enter relay for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="relay"
                        value={credentials.relay}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Port</h4>
                      <p>Enter port for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="port"
                        value={credentials.port}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>State</h4>
                      <p>Enter state for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        placeholder=""
                        name="state"
                        value={credentials.state}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Comment</h4>
                      <p>Enter comment for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <textarea
                        name="comment"
                        id=""
                        cols="30"
                        rows="7"
                        value={credentials.comment}
                        onChange={handleInput}
                      ></textarea>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              </>
              )}

              {departmentAccess && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Department</h4>
                      <p>Select a department for this site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="department_id"
                        value={credentials.department_id || ""}
                        onChange={(e) => {
                          const selected = departments.find(
                            (item) => item._id === e.target.value
                          );
                          setQrImage("");
                          setCredentials((prev) => ({
                            ...prev,
                            department_id: selected?._id || "",
                            department_name: selected?.name || "",
                            pin_code: String(selected?.universal_code || "").trim(),
                          }));
                        }}
                      >
                        <option value="">Choose Department</option>
                        {departments.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.name}
                          </option>
                        ))}
                        {credentials.department_name &&
                          !departments.some(
                            (item) =>
                              item._id === credentials.department_id ||
                              String(item.name || "").trim().toLowerCase() ===
                                String(credentials.department_name || "")
                                  .trim()
                                  .toLowerCase()
                          ) && (
                            <option value={credentials.department_id || credentials.department_name}>
                              {credentials.department_name}
                            </option>
                          )}
                      </select>
                      {credentials.department_name ? (
                        <div className="mt-3">
                          <button
                            type="button"
                            className="btn btn-prim w-auto"
                            onClick={generatePasswordQr}
                          >
                            Generate QR Code
                          </button>
                          {qrImage ? (
                            <div className="mt-3">
                              <img
                                src={qrImage}
                                alt="Locker password QR code"
                                width={220}
                                height={220}
                              />
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              )}
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Password</h4>
                      <p>The selected department's universal code</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Department code"
                        name="pin_code"
                        value={credentials.pin_code || ""}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12 text-end">
                <div className="form-btn-wrap mb-5 pb-5">
                  <button
                    type="submit"
                    className="btn btn-prim w-auto ms-5"
                    disabled={isLoading}
                  >
                    {isLoading ? "updating..." : "Update Locker"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LockerEdit;
